module.exports = __webpack_public_path__ + "static/media/desmos.27ee1044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desmos.png
// module id = 1728
// module chunks = 2